import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import echarts from "echarts";
// import global from "@/utils/global.js";
import "./plugins/element.js";
import "@/assets/scss/element-variables.scss";
import "@/assets/scss/global.scss";
import "@/assets/font/iconfont.css";
import Router from "vue-router";
import store from "@/plugins/store";
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
Vue.config.productionTip = false;

Vue.prototype.$echarts = echarts;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
